import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { Store } from "@ngxs/store";

import { HomeActions } from "../state/home.actions";

@UntilDestroy()
@Component({
    templateUrl: "./home.component.html",
    styleUrls: ["home.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit {
    constructor(private store: Store) {}

    public ngOnInit(): void {
        this.store.dispatch(new HomeActions.Load());
    }
}
